/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Grid, Typography, Button, FormControl, FormHelperText } from '@mui/material'
import { CheckboxWithLabel } from "formik-mui";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Box from '@mui/material/Box';
import { CircularProgress } from '@mui/material'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { TextField } from 'formik-mui'
import { makeStyles } from 'tss-react/mui';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import Resizer from "react-image-file-resizer";
import { Alert, Avatar } from '@mui/material';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import { register } from '../../../services/user/UserController';
import { toast } from 'react-toastify';
import { IMAGES } from '../../../config/assets';

const RegisterPage = ({ ...props }) => {

    const [showPassword, setShowPassword] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const [loading, setLoading] = useState(false);
    const [avatar, changeAvatar] = useState('');
    const [errorValidation, setErrorValidation] = useState('');
    const navigate = useNavigate()
    let fileloader = React.createRef();
    const { classes } = useStyles();
    const handleSubmit = async (user, { setSubmitting }) => {
        setSubmitting(true);
        setLoading(true);
        setInProgress(true)

        const newUserWithToken = {
            firstname: user.firstname,
            lastname: user.lastname,
            username: user.username,
            passwordhash: user.password,
            cellphone: user.cellphone,
            email: user.email,
            emailvalidated: false,
            cellphonevalidated: false,
            useravatar: avatar,
         }
        try {
            await register(newUserWithToken)
            setSubmitting(false);
            setLoading(false);
            setInProgress(false);
            navigate("/login");
            toast.success('Registred successfully.')
        } catch (error) {
            setSubmitting(false);
            setLoading(false);
            setInProgress(false);
            setErrorValidation("somethin went wrong, please try later.")
        }

    }
    const onLoadFile = async (file) => {
        await resizeFile(file);

    };
    const resizeFile = (file) => {
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                300,
                300,
                "JPEG",
                300,
                0,
                (uri) => {
                    resolve(uri);
                    changeAvatar(uri);
                },
                "base64"
            );
        });
    }
    return (
        <Box m={6}>

            <Grid container  >
                <Grid item xs={12} sm={1} md={1} />

                <Grid item xs={12} sm={10} md={10}>

                    <Grid container className={classes.containerBox} >
                        <Grid item xs={12} sm={12} md={3} />
                        <Grid item xs={12} sm={12} md={6} >
                            <Box m={2} className={classes.BoxContainerLogin} >
                                <Link
                                    to={"/"}
                                >
                                    <img src={IMAGES.LOGO_DARK} alt="" height="80px" className='AlignCenter' />
                                </Link>
                                <Typography color="primary" variant="h1" align="center">
                                    Register

                                </Typography>
                                <Grid container >

                                    <Grid item xs={12} sm={12} md={12}>

                                        <Formik
                                            initialValues={{
                                                username: '',
                                                password: '',
                                                firstname: '',
                                                lastname: '',
                                                cellphone: '',
                                                confirmPassword: '',
                                                agree: false,
                                                email: ''
                                            }}
                                            validationSchema={Yup.object().shape({
                                                username: Yup.string().min(6).max(24).required(),
                                                password: Yup.string().min(8).max(30).required(),
                                                firstname: Yup.string().min(4).max(24).required(),
                                                lastname: Yup.string().min(4).max(24).required(),
                                                cellphone: Yup.string().min(8).max(12).required(),
                                                email: Yup.string().email().required(),
                                                agree: Yup.boolean()
                                                    .required("The terms and conditions must be accepted.")
                                                    .oneOf([true], "The terms and conditions must be accepted."),
                                                confirmPassword: Yup.string().min(8).max(30).oneOf([Yup.ref('password'), null], 'Passwords must match').required('password is required'),

                                            })}

                                            onSubmit={(
                                                { username, password, firstname, lastname, cellphone, email }, { setSubmitting }
                                            ) => {
                                                handleSubmit({ username, password, firstname, lastname, cellphone, email }, { setSubmitting })
                                            }
                                            }
                                        >
                                            {({ isSubmitting, values, errors, touched, handleBlur, handleChange, setFieldValue }) => (

                                                <Grid container spacing={6} >
                                                    <Grid item xs={12} sm={12} md={12}>
                                                        <Form style={{ padding: '20px' }}>
                                                            <FormControl fullWidth error={Boolean(touched.username && errors.username)}>

                                                                <Field
                                                                    name="username"
                                                                    label="Username"
                                                                    type="text"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.username}
                                                                    margin="normal"
                                                                    variant="outlined"

                                                                    component={TextField}

                                                                />

                                                            </FormControl>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} sm={6} md={6}>
                                                                    <FormControl fullWidth error={Boolean(touched.password && errors.password)}>

                                                                        <Field
                                                                            name="password"
                                                                            label="Password"
                                                                            type={showPassword ? "text" : 'password'}
                                                                            onBlur={handleBlur}
                                                                            onChange={handleChange}
                                                                            margin="normal"
                                                                            variant="outlined"

                                                                            value={values.password}
                                                                            component={TextField}
                                                                            InputProps={{

                                                                                endAdornment: (
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton
                                                                                            onClick={() => setShowPassword(showPassword => !showPassword)}
                                                                                        >
                                                                                            {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                )
                                                                            }}
                                                                        />

                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} md={6}>
                                                                    <FormControl fullWidth error={Boolean(touched.confirmPassword && errors.confirmPassword)}>

                                                                        <Field
                                                                            value={values.confirmPassword}
                                                                            component={TextField}

                                                                            name="confirmPassword"
                                                                            label="Confirm Password"
                                                                            type={showPassword ? "text" : 'password'}
                                                                            onBlur={handleBlur}
                                                                            onChange={handleChange}
                                                                            margin="normal"
                                                                            variant="outlined"

                                                                            InputProps={{

                                                                                endAdornment: (
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton
                                                                                            onClick={() => setShowPassword(showPassword => !showPassword)}
                                                                                        >
                                                                                            {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                )
                                                                            }}
                                                                        />

                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} md={6}>
                                                                    <FormControl fullWidth error={Boolean(touched.firstname && errors.firstname)}>

                                                                        <Field
                                                                            value={values.firstname}
                                                                            component={TextField}

                                                                            name="firstname"
                                                                            label="Firstname"
                                                                            type="text"
                                                                            onBlur={handleBlur}
                                                                            onChange={handleChange}
                                                                            margin="normal"
                                                                            variant="outlined"

                                                                        />

                                                                    </FormControl>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6} md={6}>
                                                                    <FormControl fullWidth error={Boolean(touched.lastname && errors.lastname)}>

                                                                        <Field
                                                                            value={values.lastname}
                                                                            component={TextField}

                                                                            name="lastname"
                                                                            label="Lastname"
                                                                            type="text"
                                                                            onBlur={handleBlur}
                                                                            onChange={handleChange}
                                                                            margin="normal"
                                                                            variant="outlined"

                                                                        />

                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} md={6}>
                                                                    <FormControl fullWidth error={Boolean(touched.email && errors.email)}>

                                                                        <Field
                                                                            value={values.email}
                                                                            component={TextField}

                                                                            name="email"
                                                                            label="Email"
                                                                            type="text"
                                                                            onBlur={handleBlur}
                                                                            onChange={handleChange}
                                                                            margin="normal"
                                                                            variant="outlined"

                                                                        />

                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} md={6}>

                                                                    <FormControl fullWidth error={Boolean(touched.cellphone && errors.cellphone)} style={{ marginTop: '16px' }}>
                                                                        <PhoneInput
                                                                            placeholder="Enter phone number"
                                                                            value={values.cellphone}
                                                                            onChange={(tel) => { setFieldValue("cellphone", tel) }}
                                                                            name="cellphone"
                                                                            label="cellphone"
                                                                        />

                                                                        {touched.cellphone && errors.cellphone && (
                                                                            <FormHelperText error id="standard-weight-helper-text-cellphone">
                                                                                {' '}
                                                                                {errors.cellphone}{' '}
                                                                            </FormHelperText>
                                                                        )}
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid container spacing={4}>
                                                                <Grid item xs={12} sm={12} md={12} style={{ marginTop: '20px' }}>
                                                                    <Grid container spacing={4}>

                                                                        <Grid item xs={3} sm={2} md={2}>

                                                                            <input
                                                                                ref={input => (fileloader = input)}
                                                                                style={{ display: 'none' }}
                                                                                type="file"
                                                                                onChange={e => onLoadFile(e.currentTarget.files[0])}
                                                                            />
                                                                            <Avatar src={avatar ? avatar : IMAGES.AVATAR_DEFAULT} className={classes.avatar}
                                                                                onClick={() => fileloader.click()} />
                                                                        </Grid>

                                                                        <Grid item xs={3} sm={3} md={3}>
                                                                            <Button color="primary" variant="outlined" onClick={() => fileloader.click()} style={{ marginTop: '20px' }}>Upload Avatar</Button>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>

                                                            </Grid>
                                                            <Grid container spacing={4} style={{ marginTop: '5px' }} >
                                                                <Grid item xs={12} sm={12} md={12}>

                                                                    <FormControl fullWidth error={Boolean(touched.agree && errors.agree)}>

                                                                        <Field
                                                                            component={CheckboxWithLabel}
                                                                            checked={values.agree}

                                                                            name="agree"
                                                                            type="checkbox"
                                                                            margin="normal"

                                                                            onBlur={handleBlur}
                                                                            onChange={handleChange}
                                                                            Label={{
                                                                                label: (
                                                                                    <>
                                                                                        <Typography variant='h5'>  I accept the <Link to="/tos" style={{ color: "#F04943" }}>terms and conditions.</Link></Typography>
                                                                                    </>
                                                                                ),
                                                                            }}
                                                                        />
                                                                        {touched.agree && errors.agree && (
                                                                            <FormHelperText error id="standard-weight-helper-text-agree">
                                                                                {' '}
                                                                                {errors.agree}{' '}
                                                                            </FormHelperText>
                                                                        )}
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>
                                                            {inProgress && <Grid container spacing={4}>
                                                                <Grid item xs={12} sm={12} md={12}>
                                                                    <Typography variant="h4" color="primary"> <CircularProgress color="secondary" size={24} />
                                                                        Please wait, This may take seconds...</Typography>
                                                                </Grid>
                                                            </Grid>}
                                                            <Grid container spacing={4} >
                                                                {errorValidation && <Alert variant='error'>{errorValidation}</Alert>}
                                                                <Grid item xs={12} sm={12} md={12}>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        className={classes.button}
                                                                        type="submit"
                                                                    >
                                                                        {loading && <CircularProgress size={24} color="secondary" className={classes.buttonProgress} />}
                                                                        Register
                                                                    </Button>
                                                                    <span>{'  '}</span>
                                                                    <Button
                                                                        className={classes.button}  >
                                                                        <Link to={"/login"} color="textPrimary" style={{ textDecoration: 'none' }}>
                                                                            <Typography variant='h5'>   Back to Login</Typography>
                                                                        </Link>
                                                                    </Button>
                                                                </Grid>
                                                            </Grid>
                                                        </Form>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </Formik>


                                    </Grid>

                                </Grid>

                            </Box>

                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
            <Grid item xs={12} sm={1} md={1} />

        </Box>

    )

}

const useStyles = makeStyles({ "name": { RegisterPage } })(theme => ({
    heroContent: {
        height: 'calc( 100vh - 150px)',
    },

    button: {
        margin: theme.spacing(1),
        color: "white"
    },

    floatingLabelFocusStyle: {
        color: theme.palette.primary.main
    },
    ImgLoginDescp: {
        width: '300px',
        margin: 'auto',
        marginLeft: "auto",
        marginRight: 'auto'
    },
    containerBox: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: '10px',
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat'
    },
    BoxContainerLogin: {
        padding: '1em',
        borderRadius: '10px',
        boxShadow: 'rgb(38 127 161) 1px 5px 24px 0px',

    },

    avatar: {
        width: '70px!important',
        height: '70px!important'

    }
}))


export default RegisterPage;
